import { Component, Input } from '@angular/core';
import { ApplicationPermissionItem } from '../customer-space-user.model';

@Component({
  selector: 'app-display-applications',
  templateUrl: './display-applications.component.html',
  styleUrls: ['./display-applications.component.scss'],
})
export class DisplayApplicationsComponent {
  @Input() applications: ApplicationPermissionItem[] = [];
  byApplicationId(index: number, item: ApplicationPermissionItem) {
    return item.key;
  }
}
